import type { PageGuide } from "../page-guide.js";

/**
 * Help guide for Committees & working groups admin (programme bodies +
 * committee meeting run).
 *
 * Deliberately mirrors the design spec's non-clunky posture: the tour
 * steps stay in the human-verb vocabulary the page itself uses
 * ("Add a chair", "Run a meeting", "Approve minutes") and never mention
 * Graph/Entra — co-authoring ("Room") is a P0 placeholder, not a live
 * feature, so it isn't taught here yet.
 */
export const programmeCollaborationGuide: PageGuide = {
  route: "/programme-collaboration",
  version: 3,
  overviewArticleId: "programme-collaboration-overview",
  steps: [
    {
      id: "bodies",
      title: "Stand up a committee or working group",
      body: "Create a **body** under the engagement — a committee or a working group — then add its roster. Use **Contacts** for people already on the partner CRM, or **Staff** to pick Latitude30 people (they are linked onto the partner as a contact automatically). Portal guests only see bodies they are seated on (contact email must match their magic-link login). Pin a **TOR**, set an **L30 contact**, and optionally a **shared folder** so guests see papers and artefacts. A body may have **at most one active chair**.",
    },
    {
      id: "meeting-run",
      title: "Run a committee meeting",
      body: "Committees step through **Prepare → Attend → Record → Close**: build the agenda (attach paper document ids in Prepare), take roster attendance (or **Mark all present**), draft minutes, then the chair or secretary **Approves minutes**. Working groups default to a lighter Notes view. Seated portal guests see approved minutes and open actions on the body.",
    },
    {
      id: "carry-forward",
      title: "Actions carry forward",
      body: "Open action items from one meeting automatically carry onto the next when you schedule it, so nothing agreed with the ministry gets lost between sessions.",
    },
  ],
  panels: [],
  guidedActions: [],
};
